import { useAtomValue, useSetAtom } from 'jotai';
import { type ReactNode, useEffect, useState } from 'react';

import { getMe } from '@/features/auth/api/auth.api';
import { accessTokenAtom, userAtom } from '@/stores/auth.store';

interface AuthProviderProps {
  children: ReactNode;
}

export function AuthProvider({ children }: AuthProviderProps) {
  const [isInitializing, setIsInitializing] = useState(true);
  const accessToken = useAtomValue(accessTokenAtom);
  const setUser = useSetAtom(userAtom);
  const setAccessToken = useSetAtom(accessTokenAtom);

  useEffect(() => {
    async function initializeAuth() {
      if (accessToken) {
        try {
          const response = await getMe();
          setUser(response.user);
        } catch {
          // Token is invalid, clear it
          setAccessToken(null);
          setUser(null);
        }
      }
      setIsInitializing(false);
    }

    initializeAuth();
  }, [accessToken, setUser, setAccessToken]);

  if (isInitializing) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-muted-foreground">Loading...</div>
      </div>
    );
  }

  return <>{children}</>;
}
